import { Badge } from "reactstrap";
import { ServerStatusType } from "../../utils";

export const StatusBadge = ({ className, status, ...props }) => {
    let color = status ? "success" : "gray";
    let text = status ? "Active" : "Inactive";
    return (
        <Badge color={color} className="fs-14px fw-light">{text}</Badge>
    );
};